import React from 'react'
import { Text, View } from 'react-native'
import { VisionPillars } from '../components/HomeSections'
import { useThemeValue } from '../ThemeContext'
import { baseFont, eyebrow, HEADER_HEIGHT } from '../utils/ui'
import { Container, ResponsiveSplit, Reveal, Section } from '../components/ui'

function StatementBlock({ color, label, text }: { color: string; label: string; text: string }) {
  const { theme } = useThemeValue()
  return (
    <View style={{ borderLeftWidth: 2, borderLeftColor: color, paddingLeft: 20, gap: 8 }}>
      <Text style={{ ...baseFont('700'), color, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 }}>{label}</Text>
      <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 24, lineHeight: 32 }}>{text}</Text>
    </View>
  )
}

export function VisionPage() {
  const { theme } = useThemeValue()
  return (
    <Section background={theme.colors.background} paddingTop={HEADER_HEIGHT + 76} paddingBottom={128}>
      <Container>
        <Reveal>
          <View style={{ maxWidth: 820, gap: 24 }}>
            <Text style={eyebrow(theme)}>Vision & Strategy</Text>
            <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 64, lineHeight: 72, letterSpacing: -2.4 }}>
              Communication that respects <Text style={{ color: theme.colors.primary }}>attention.</Text>
            </Text>
            <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 20, lineHeight: 32 }}>
              Relayably exists to help people and businesses handle growing communication without losing time, focus, or opportunities.
            </Text>
            <StatementBlock color={theme.colors.primary} label="Our Vision" text="To create a world where communication respects human attention." />
            <StatementBlock color={theme.colors.tertiary} label="Our Mission" text="To make call handling simple for the people who need it most." />
          </View>
        </Reveal>

        <View style={{ marginTop: 96 }}>
          <Text style={eyebrow(theme)}>The Strategic Narrative</Text>
          <ResponsiveSplit
            topMargin={40}
            left={
              <View style={{ gap: 18 }}>
                <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 36, lineHeight: 42, letterSpacing: -1.6 }}>
                  Communication overload is the{'\n'}
                  <Text style={{ color: theme.colors.primary }}>everyday problem</Text> of the AI era.
                </Text>
                <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 18, lineHeight: 29 }}>
                  As automation makes it cheaper and easier to contact people, the volume of calls and messages keeps rising.
                </Text>
              </View>
            }
            right={
              <View style={{ gap: 18 }}>
                <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 16, lineHeight: 28 }}>
                  Relayably answers calls, filters the noise, handles simple tasks, and keeps people informed about what matters.
                </Text>
                <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 16, lineHeight: 28 }}>
                  It gives small businesses and busy professionals a simpler way to stay responsive without needing complicated tools or extra staff.
                </Text>
              </View>
            }
          />
        </View>
        <VisionPillars />
      </Container>
    </Section>
  )
}
